import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Stack,
  Typography,
  Divider,
  Box,
} from "@mui/material";
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";
import moment from "moment";

const fmtImporte = (v) =>
  v == null
    ? "-"
    : new Intl.NumberFormat("es-AR", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(v);

function Dato({ label, children }) {
  return (
    <Box sx={{ minWidth: 140 }}>
      <Typography variant="caption" color="text.secondary" display="block">
        {label}
      </Typography>
      <Typography variant="body2" fontWeight={600}>
        {children ?? "-"}
      </Typography>
    </Box>
  );
}

// Popup de confirmación al encontrar la factura en el CSV de ARCA. Muestra el resumen
// (datos del staging) en solo-lectura; al aceptar, el flujo abre el form precargado.
export default function ArcaEncontradoDialog({ open, row, onClose, onAceptar }) {
  if (!row) return null;
  const pv = String(row.punto_venta ?? "").padStart(4, "0");
  const nro = String(row.nro_desde ?? "").padStart(8, "0");

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle sx={{ display: "flex", alignItems: "center", gap: 1 }}>
        <ReceiptLongIcon color="primary" />
        Comprobante encontrado
      </DialogTitle>
      <DialogContent dividers>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
          Se encontró la factura en el archivo de ARCA. Revisá los datos y confirmá
          para cargarla con los campos autocompletados.
        </Typography>
        <Stack spacing={2}>
          <Box>
            <Typography variant="caption" color="text.secondary" display="block">
              Proveedor
            </Typography>
            <Typography variant="body1" fontWeight={700}>
              {row.denominacion_emisor ?? "-"}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              CUIT {row.cuit_emisor ?? "-"}
            </Typography>
          </Box>
          <Divider />
          <Stack direction="row" spacing={3} rowGap={2} flexWrap="wrap" useFlexGap>
            <Dato label="Tipo (cód. ARCA)">{row.tipo_comprobante_arca ?? "-"}</Dato>
            <Dato label="Punto de venta - Número">{`${pv}-${nro}`}</Dato>
            <Dato label="Fecha">
              {row.fecha_emision
                ? moment(row.fecha_emision).format("DD-MM-YYYY")
                : "-"}
            </Dato>
            <Dato label="Moneda">{row.moneda ?? "-"}</Dato>
            <Dato label="Total">{fmtImporte(row.imp_total)}</Dato>
          </Stack>
        </Stack>
      </DialogContent>
      <DialogActions sx={{ px: 3, py: 2 }}>
        <Button onClick={onClose} color="inherit">
          Cancelar
        </Button>
        <Button onClick={onAceptar} variant="contained">
          Aceptar
        </Button>
      </DialogActions>
    </Dialog>
  );
}
